var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
import { forwardRef } from "react";
const SvgDisplayMediumPrimaryLoans = (_ref, ref) => {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 50,
    height: 50,
    viewBox: "0 0 50 50",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M0 0H50V50H0z"
  }), /*#__PURE__*/React.createElement("g", {
    fill: "#1B7690",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M30.69 13.668c2.97 0 5.363-2.397 5.363-5.363 0-2.966-2.424-5.362-5.363-5.362-2.939 0-5.362 2.396-5.362 5.362-.03 2.966 2.393 5.363 5.362 5.363zM16.665 11.193c2.97 0 5.363-2.397 5.363-5.363 0-2.966-2.424-5.362-5.363-5.362-2.939 0-5.362 2.396-5.362 5.362s2.423 5.363 5.362 5.363zM4.702 19.442H1.827c-.698 0-1.25.554-1.25 1.253v9.87c0 .7.552 1.252 1.25 1.252h2.875V19.442zM43.102 17.843c-2.385-2.483-6.272-2.483-8.657 0l-3.828 3.984-1.56 1.625c-.619.644-1.502 1.042-2.386 1.042h-7.597c-.677 0-1.266-.552-1.295-1.257-.03-.766.559-1.379 1.266-1.379h7.715c1.56 0 2.915-1.165 3.18-2.759.059-.367.088-.735.088-1.134 0-.735-.56-1.318-1.266-1.318h-4.24c-1.384 0-2.71-.644-4.123-1.349-1.472-.735-3.003-1.47-4.77-1.593-1.56-.123-3.121.06-4.652.52-1.62.491-2.798 1.993-2.945 3.74h-.03v13.027H29.94c1.501 0 2.915-.613 4.004-1.716l9.158-9.533c.5-.552.5-1.38 0-1.9z",
    transform: "translate(3 9)"
  }))))));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgDisplayMediumPrimaryLoans);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/display-medium-primary-loans.e31d494d7a0b797f773adf077bb29d67.svg";